// EmailJS Configuration
// =====================
// To make this work, follow these steps:
//
// 1. Go to https://www.emailjs.com and create a FREE account
// 2. Add your email service (Gmail, Outlook, etc.) under "Email Services"
// 3. Create 2 email templates under "Email Templates":
//
//    Template 1: "Appointment Booking" (template_appointment)
//    Subject: New Appointment Request from {{fullName}}
//    Body:
//      Name: {{fullName}}
//      Phone: {{phone}}
//      Email: {{email}}
//      Date: {{preferredDate}}
//      Time: {{preferredTime}}
//      Service: {{service}}
//      Message: {{message}}
//
//    Template 2: "Contact Form" (template_contact)
//    Subject: New Contact: {{subject}}
//    Body:
//      Name: {{name}}
//      Email: {{email}}
//      Phone: {{phone}}
//      Subject: {{subject}}
//      Message: {{message}}
//
// 4. Copy your Service ID, Template IDs, and Public Key below:

export const EMAILJS_CONFIG = {
  PUBLIC_KEY: 'NLIN40Z3nlUY2a2iL',
  SERVICE_ID: 'service_8b812hm',
  APPOINTMENT_TEMPLATE_ID: 'template_900yucn',
  CONTACT_TEMPLATE_ID: 'template_ga3ijnj',
};

export const isEmailJSConfigured = (): boolean => {
  return (
    EMAILJS_CONFIG.PUBLIC_KEY !== 'YOUR_PUBLIC_KEY' &&
    EMAILJS_CONFIG.SERVICE_ID !== 'YOUR_SERVICE_ID'
  );
};

interface EmailJSResponse {
  status: number;
  text: string;
}

export const sendEmail = async (
  templateId: string,
  templateParams: Record<string, string>
): Promise<EmailJSResponse> => {
  const response = await fetch('https://api.emailjs.com/api/v1.0/email/send', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      service_id: EMAILJS_CONFIG.SERVICE_ID,
      template_id: templateId,
      user_id: EMAILJS_CONFIG.PUBLIC_KEY,
      template_params: templateParams,
    }),
  });

  if (response.ok) {
    return { status: 200, text: 'OK' };
  }
  throw new Error('Failed to send email');
};
